import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import MuiAlert from '@material-ui/lab/Alert';
import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import {
    setInfo,
    closeInfo,
} from '../actions';

const useStyles = makeStyles((theme) => ({
    close: {
        padding: theme.spacing(0.5),
    },
}));

const Snack = (props) => {
    const classes = useStyles();
    return (
        <Snackbar
            key={props.info}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            open={props.info.length > 0}
            autoHideDuration={8000}
            onClose={props.closeInfo}
        >
            <MuiAlert elevation={6} variant="filled" severity={props.status === 200 ? 'success' : 'error'}>
                {props.info}

                <IconButton
                    aria-label="close"
                    color="inherit"
                    className={classes.close}
                    onClick={props.closeInfo}
                >
                    <CloseIcon />
                </IconButton>
            </MuiAlert>
        </Snackbar>
    );
}

const mapStateToProps = ({ snack, auth }) => {
    let info = '';
    let status = 0;
    if (snack.info) {
        info = snack.info;
        status = snack.status;
    } else if (auth.info) {
        info = auth.info;
        status = auth.status;
    }

    return { info, status }
}

export default connect(mapStateToProps, { setInfo, closeInfo })(Snack);
